import { Reducer } from 'redux'
import { fromJS } from 'immutable'
import { IColaboraLayout } from './../models'
import * as TYPES from './../actionTypes'

export const initialState: IColaboraLayout = fromJS({
  loading: false,
  path: {},
  intro_section: {},
  where_we_are_section: {},
  collaborate_section: {},
  example_section: {},
  companies_section: {},
})

const colaboraLayoutReducer: Reducer<IColaboraLayout> = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.SET:
      return state.merge(action.payload)
    case TYPES.CONTENT.REQUEST:
      return state.set('loading', true)
    case TYPES.CONTENT.FULFILL:
      return state.set('loading', false)
    case TYPES.CONTENT.FAILURE:
      return state.set('error', action.payload)
    case TYPES.CONTENT.SUCCESS:
      return state.merge(action.payload)
    default:
      return state
  }
}

export default colaboraLayoutReducer
